import React from "react";
import { Dialog, DialogContent, Button } from "@mui/material";
import ModalCloseButton from "../../components/UI/ModalCloseButton";

function ExitConfirmDialog({ open, onClose, onConfirm }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      PaperProps={{
        style: {
          borderRadius: "4px",
          padding: "24px",
          position: "relative",
        },
      }}
    >
      <ModalCloseButton onClick={onClose} />

      <DialogContent
        style={{ padding: 0, textAlign: "center", marginTop: "12px" }}
      >
        <h2
          style={{
            fontFamily: "Poppins",
            fontWeight: 400,
            color: "#444444",
            fontSize: "20px",
            margin: "0 0 24px 0",
          }}
        >
          Are you sure you want to exit this report?
        </h2>
        <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
          <Button
            onClick={onConfirm}
            style={{
              fontSize: "14px",
              fontFamily: "Poppins",
              fontWeight: 500,
              backgroundColor: "white",
              color: "#0F9BB0",
              textTransform: "none",
              border: "2px solid",
              borderColor: "#0F9BB0",
              padding: "8px 24px",
              minWidth: "120px",
              borderRadius: "4px",
            }}
          >
            Yes, exit
          </Button>
          <Button
            onClick={onClose}
            style={{
              fontSize: "14px",
              fontFamily: "Poppins",
              fontWeight: 500,
              backgroundColor: "#0F9BB0",
              color: "white",
              textTransform: "none",
              padding: "8px 24px",
              minWidth: "120px",
              borderRadius: "4px",
            }}
          >
            No, stay here
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default ExitConfirmDialog;
